module.exports = __webpack_public_path__ + "img/reward-title-pic.7e1d84e3.png";